module.exports = __webpack_public_path__ + "static/media/Redux.62cc7d7a.png";